import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const Service = {}
Service.getDataAll = function (token) {

    return fetch({
        url: '/ref/kota',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

Service.getDataByIDKota = function (token,id) {

    return fetch({
        url: '/ref/kota',
        method: 'get',
        params: {
            "id_kota":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

Service.getDataByIDPropinsi = function (token,id) {
    return fetch({
        url: '/ref/kota',
        method: 'get',
        params: {
            "id_propinsi":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}
export default Service;
